import { render, staticRenderFns } from "./DetailGrid.vue?vue&type=template&id=73e36a5e&scoped=true&"
import script from "./DetailGrid.vue?vue&type=script&lang=js&"
export * from "./DetailGrid.vue?vue&type=script&lang=js&"
import style0 from "./DetailGrid.vue?vue&type=style&index=0&id=73e36a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e36a5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e36a5e')) {
      api.createRecord('73e36a5e', component.options)
    } else {
      api.reload('73e36a5e', component.options)
    }
    module.hot.accept("./DetailGrid.vue?vue&type=template&id=73e36a5e&scoped=true&", function () {
      api.rerender('73e36a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/menu-entry/grid/DetailGrid.vue"
export default component.exports